export default "__VITE_ASSET__B3G2MBhT__"